module.exports = __webpack_public_path__ + "static/tooltip-c018bea5ca81dbb1ab531a1e44b20dc3.png";